<template>
  <b-overlay :show="showOverlay">
    <b-col class="mb-1 bg-white p-0" cols="12">
      <DynamicBreadCrumb :items="pageBreadcrumb"></DynamicBreadCrumb>
    </b-col>
    <validation-observer ref="createGameService" tag="div">
      <b-card class="data-edit-wrapper">
        <h2>Create Game Service </h2>
        <b-form class="mt-2">
          <b-row>
            <b-col class="" md="4">
              <b-form-group
                  label="Title"
              >
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                  <b-form-input
                      id="data-edit-seoTitle"
                      v-model="data.title"
                      :state="errors.length > 0 ? false:null"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col class="" md="4">
              <b-form-group
                  label="Game Service Detail Name"
              >
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                  <b-form-input
                      id="data-edit-seoTitle"
                      v-model="data.gameServiceDetailName"
                      :state="errors.length > 0 ? false:null"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                  label="Game Service Type"

              >
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                  <v-select
                      v-model="data.gameServiceType"
                      :class="{'border-danger rounded':errors.length > 0 ? true:null}"
                      :options="gameServiceTypes"
                      :reduce="title => title.id"
                      dir="ltr"
                      label="title"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="8">
              <b-form-group
                  label="Short Description"

              >
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                  <b-form-input
                      id="data-edit-seoTitle"
                      v-model="data.shortDescription"
                      :state="errors.length > 0 ? false:null"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-row>
                <b-col cols="9" md="3">
                  <b-form-group
                      label="Offers"
                  >
                    <b-form-input
                        id="data-edit-seoTitle"
                        v-model="offerName"
                    />
                  </b-form-group>
                </b-col>
                <b-col class="d-flex align-items-center " cols="3" md="2">
                  <b-button
                      class=" mt-1"
                      variant="warning"
                      @click="addOffer"
                  >
                    Add
                  </b-button>
                </b-col>
                <b-col v-if="data.offers.length>0" cols="12" >
                  <div class="d-flex align-items-center ">
                    <b-badge
                        v-for="(item,idx) in data.offers"
                        class="d-flex align-items-center mx-25"
                        pill
                        variant="primary"
                    >
                      <span>
                      {{ item }}
                      </span>
                      <feather-icon class="cursor-pointer" icon="XIcon" @click="data.offers.splice(idx,1)"
                      ></feather-icon>
                    </b-badge>
                  </div>
                </b-col>
              </b-row>


            </b-col>
            <b-col class="mt-1" cols="12">
              <b-form-group
                  label="Full Description"
              >

                <ckEditorMain ref="editorContent" :defaultContent="data.fullDescription"
                              @getEditorContent="setEditorContent"
                ></ckEditorMain>

              </b-form-group>

            </b-col>
            <b-col class="my-1" cols="12">
              <b-form-group
                  label="Background Picture"
              >
                <MediaHandler ref="mediaHandlerBackground" @sendData="setFilesBackground"></MediaHandler>

              </b-form-group>

            </b-col>
            <b-col class="my-1" cols="12">
              <b-form-group
                  label="Item Picture"
              >
                <MediaHandler ref="mediaHandlerItem" @sendData="setFilesItem"></MediaHandler>

              </b-form-group>

            </b-col>


          </b-row>
        </b-form>
      </b-card>
      <b-card>
        <b-row>
          <b-col v-if="data" cols="12" md="12">
            <h2>SEO</h2>
          </b-col>
          <b-col class="" cols="12" md="4">
            <b-form-group
                label="Seo Title"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-input
                    id="data-edit-seoTitle"
                    v-model="data.seoTitle"
                    :state="errors.length > 0 ? false:null"
                />
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col class="" cols="12" md="4">
            <b-form-group
                label="Seo Url"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-input
                    id="data-edit-seoTitle"
                    v-model="allCharactersToDash"
                    :state="errors.length > 0 ? false:null"
                />
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col class="" cols="12">
            <b-form-group
                label="Seo Description"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >

                <b-form-textarea
                    id="data-edit-seoTitle"
                    v-model="data.seoDescription"
                    :state="errors.length > 0 ? false:null"
                />
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="pl-1">
            <div class="col-md-12 ">
              <!--- serp Desktop --->
              <div class="serp-preview d-lg-flex d-none flex-column align-items-start">
                <div class="serp-title">
                  <h4 style="color: rgb(26, 13, 171)!important">
                    {{ data.seoTitle }}
                  </h4>
                </div>
                <div class="serp-url">
                  <h5 class="d-flex align-items-center flex-wrap" style="color: rgb(0, 102, 33)!important">
                    <span>https://boostallin.com/[game-name]/[game-service-category-name]/<span class="serp-arrow"></span></span>
                    <span style="overflow-wrap: anywhere">
                      {{ data.seoUrl.replaceAll(' ', '-') }}
                    </span>

                  </h5>
                </div>
                <div class="serp-description">
                  <h6 style="overflow-wrap: anywhere">
                    {{ data.seoDescription }}
                  </h6>
                </div>
              </div>
              <!--- serp Mobile --->
              <div class="serp-preview d-lg-none  p-1 d-flex flex-column align-items-start">
                <div class="serp-title">
                  <h6>
                    {{ data.seoTitle }}
                  </h6>
                </div>
                <div class="serp-url d-flex align-items-center flex-wrap">

                  <small>{{ data.seoUrl.replaceAll(' ', '-') }}/</small>
                  <small>
                    https://boostallin.com/[game-name]/[game-service-category-name]/
                    <small class="serp-arrow"></small>
                  </small>
                </div>
                <div class="serp-description">
                  <small>
                    {{ data.seoDescription }}
                  </small>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="3">
            <b-button
                class="btn-tour-skip mr-1"
                variant="primary"
                @click="createData"
            >
              <span class="mr-25 align-middle">Submit</span>

            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>

  </b-overlay>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import ckEditorMain from '@/views/components/ckEditorMain'
import Helper from '@/libs/Helper'
import MediaHandler from '@/views/components/utilities/MediaHandler.vue'
import { CreateGameService } from '@/libs/Api/gameService'
import DynamicBreadCrumb from '@/views/components/utilities/DynamicBreadCrumb.vue'

export default {
  components: {
    DynamicBreadCrumb,
    MediaHandler,
    BFormTextarea,
    BForm,
    ValidationProvider,
    ckEditorMain,
    BCard,
    ValidationObserver,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,
    BBadge,
    BOverlay,
    vSelect,
  },
  name: 'create-game-service',
  title: 'create game service',
  data() {
    return {
      //service 1
      // gold 2
      required,
      showOverlay: false,
      baseUrl: Helper.baseUrl,
      offerName: '',
      gameServiceTypes: [
        {
          title: 'service',
          id: 1
        },
        {
          title: 'gold',
          id: 2
        }
      ],
      parentId: '',
      pageBreadcrumb: [
        {
          text: 'Manage Games',
          href: '/apps/games/manage-games',
          active: false
        },
        {
          text: `Manage Game`,
          href: `/apps/games/manage-game?gameId=${this.$route.query.gameId}`,
          active: false
        },
        {
          text: `Manage Game Service Category`,
          href: `/apps/games/game-service-categories/manage-game-service-category?gameId=${this.$route.query.gameId}&gameServiceCategoryId=${this.$route.query.gameServiceCategoryId}`,
          active: false
        },
        {
          text: `Create Game Service`,
          href: `/apps/games/game-service-categories/game-service/create-game-service?gameId=${this.$route.query.gameId}&gameServiceCategoryId=${this.$route.query.gameServiceCategoryId}`,
          active: true
        },
      ],
      data: {
        title: '',
        offers: [],
        BackgroundImageFile: null,
        ItemImageFile: null,
        gameServiceType: null,
        gameServiceDetailName: '',
        fullDescription: '',
        shortDescription: '',
        gameServiceCategoryId: this.$route.query.gameServiceCategoryId,
        seoUrl: '',
        seoTitle: '',
        seoDescription: '',
      },
    }
  },
  computed: {
    allCharactersToDash: {
      get: function () {
        return this.data.seoUrl
      },
      set: function (newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.data.seoUrl = newValue
          // Remove all characters that are NOT number
          this.data.seoUrl = this.data.seoUrl.replace(/[+*!@#$%^&*()_;:~`»«,×='"|<>/?{}\-/\.]/g, '-')
          this.data.seoUrl = this.data.seoUrl.replaceAll(' ', '-')
        } else if (!newValue || this.data.seoUrl === '') {
          this.data.seoUrl = null
        }
      },
    },
  },
  async created() {

  },
  methods: {
    async setFilesItem(data) {
      if (data) {
        this.data.ItemImageFile = data
      }
    },
    async setFilesBackground(data) {
      if (data) {
        this.data.BackgroundImageFile = data
      }
    },
    addOffer() {
      if (this.data.offers.length <= 2 && this.offerName !== '') {
        this.data.offers.push(this.offerName)
        this.offerName = ''
      } else {
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `warning`,
            icon: 'AlertIcon',
            variant: 'danger',
            text: 'cannot add more than 3 offers',
          },
        })
      }
    },
    setEditorContent(content) {
      this.data.fullDescription = content
    },
    async createData() {
      let _this = this
      Helper.validateForm(_this, 'createGameService', async () => {
        _this.showOverlay = true
        let createGameService = new CreateGameService(_this)
        this.$refs.mediaHandlerBackground.sendFiles()
        this.$refs.mediaHandlerItem.sendFiles()
        createGameService.setParams({
          gameServiceType: _this.data.gameServiceType,
          gameServiceCategoryId: _this.$route.query.gameServiceCategoryId
        })
        let myForm = await Helper.makeFormData(this.data)
        createGameService.setFormData(myForm)
        await createGameService.sendFormData(function (content) {
          _this.showOverlay = false
          if (content.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: `Done`,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            _this.$router.push(`/apps/games/game-service-categories/manage-game-service-category/?gameId=${_this.$route.query.gameId}&gameServiceCategoryId=${_this.$route.query.gameServiceCategoryId}`)
          } else {
            return _this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                text: content.message,
                title: `error`,
                variant: 'danger',
              },
            })
          }
        }, function (error) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              text: error.message,
              title: `error`,
              variant: 'danger',
            },
          })
          _this.showOverlay = false
        })
      })
    },

  }
}
</script>

<style scoped>

</style>
